import * as React from 'react';
import { useFormContext, Controller, ValidationRule } from 'react-hook-form';
import get from 'lodash/get';
import GoogleMapsAutoCompleteInput, {
  IGoogleMapsInputProps,
} from '../GoogleMapsAutocompleteInput';

interface IProps extends Omit<IGoogleMapsInputProps, 'onChange' | 'value'> {
  name: string;
  validate?: ValidationRule;
  className?: string;
  defaultValue?: string;
}
export const GoogleMapsInput = ({
  name,
  validate,
  className,
  defaultValue,
  ...autoCompleteInputProps
}: IProps) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      rules={validate}
      name={name}
      control={control}
      render={({ field }) => (
        <GoogleMapsAutoCompleteInput
          onChange={field.onChange}
          value={field.value || defaultValue}
          name={name}
          errors={get(errors, name)}
          {...autoCompleteInputProps}
          className={`${className}`}
        />
      )}
    />
  );
};
